export default function MoonIcon() {
  return (
    <svg viewBox="0 0 53 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 0.97374C21.3416 1.38888 21.5509 1.89694 21.6009 2.43227C21.6508 2.9676 21.539 3.50559 21.28 3.97674C19.2565 7.6919 18.1998 11.8563 18.207 16.0867C18.207 30.1602 29.68 41.5562 43.82 41.5562C45.6645 41.5562 47.46 41.3637 49.1855 40.9962C49.7144 40.8817 50.2654 40.9255 50.7696 41.1222C51.2738 41.3189 51.7089 41.6598 52.0205 42.1022C52.3495 42.5623 52.5172 43.1182 52.4976 43.6834C52.4779 44.2487 52.2721 44.7916 51.912 45.2277C49.1669 48.5998 45.7039 51.3167 41.7754 53.1804C37.847 55.0441 33.5521 56.0076 29.204 56.0007C13.069 56.0007 0 43.0017 0 26.9857C0 14.9317 7.399 4.59274 17.934 0.21074C18.4588 -0.0110489 19.0414 -0.05657 19.5942 0.0810144C20.1471 0.218599 20.6404 0.53186 21 0.97374Z"
        fill="white"
      />
    </svg>
  );
}
